'use server';

import request from '../../../../api/request';
import { actionKitImpFunction } from '../../../../components/ozmoit/common';
import {
  DebtsDataParams,
  PaymentHubDebt,
  RegisterPaymentParams,
} from '../types';

const getDebtsDataAction = actionKitImpFunction(
  async (params: DebtsDataParams) => {
    if (!params.identificationDocument || !params.identificationDocumentType) {
      return [];
    }
    const response = await request<PaymentHubDebt[]>(
      'maintainers-portal/payment-hub/debts/list',
      { params },
    );
    if (response.error) {
      throw new Error('Error fetching debts data');
    }
    return response.data;
  },
);

const registerPaymentAction = actionKitImpFunction(
  async (data: RegisterPaymentParams) => {
    const response = await request<PaymentHubDebt[]>(
      `maintainers-portal/payment-hub/debts/create`,
      { method: 'POST', data },
    );
    if (response.error) {
      throw new Error(
        response.error?.data?.message || 'Error registering payment',
      );
    }
    return response.data;
  },
);

export { getDebtsDataAction, registerPaymentAction };
